import { EngineCapabilities } from '../shared/capabilities';

export enum ProtocolFlags {
  RESUME = 1 << 0,
  BACKGROUND = 1 << 1,
  FOLDER = 1 << 2,
  PREVIEW = 1 << 3,
  STREAM = 1 << 4,
  MULTI_PEER = 1 << 5,
}

export function encodeCapabilities(caps: EngineCapabilities): number {
  let flags = 0;
  if (caps.resume) flags |= ProtocolFlags.RESUME;
  if (caps.background) flags |= ProtocolFlags.BACKGROUND;
  if (caps.folder) flags |= ProtocolFlags.FOLDER;
  if (caps.preview) flags |= ProtocolFlags.PREVIEW;
  if (caps.stream) flags |= ProtocolFlags.STREAM;
  if (caps.multiPeer) flags |= ProtocolFlags.MULTI_PEER;
  return flags;
}

export function decodeCapabilities(flags: number): EngineCapabilities {
  return {
    resume: (flags & ProtocolFlags.RESUME) !== 0,
    background: (flags & ProtocolFlags.BACKGROUND) !== 0,
    folder: (flags & ProtocolFlags.FOLDER) !== 0,
    preview: (flags & ProtocolFlags.PREVIEW) !== 0,
    stream: (flags & ProtocolFlags.STREAM) !== 0,
    multiPeer: (flags & ProtocolFlags.MULTI_PEER) !== 0,
  };
}
